export default __webpack_public_path__ + "static/media/MiniTape_SideA_09_Interview-Fabian-Schwander-Part2.e7aae6a2.mp3";